document.addEventListener("DOMContentLoaded", function () {
  var video_blocks = document.getElementsByClassName('seventy-thirty-block');

  if (video_blocks.length > 0) {
    var _loop = function _loop(i) {
      var iframe = video_blocks[i].getElementsByTagName('iframe')[0];

      if (iframe) {
        if (iframe.src.includes('vimeo')) {
          playerVimeo = new Vimeo.Player(iframe); //console.log('vimeo video added');
        } else {
          //console.log('youtube video added');
          tag = document.createElement('script');
          tag.src = "https://www.youtube.com/iframe_api";
          firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        var play_button = video_blocks[i].getElementsByClassName('play-button')[0];
        var preview = video_blocks[i].getElementsByClassName('preview')[0]; //if(playerVimeo) {

        if (play_button) {
          play_button.addEventListener('click', function () {
            //console.log('play button has been clicked');
            toggle_play_status('hide');

            if (playerVimeo) {
              playerVimeo.play();
            } else {
              console.log('youtube play');
              iframe.src += "?enablejsapi=1&autoplay=1";
            }
          });

          if (playerVimeo) {
            playerVimeo.on('play', function () {
              toggle_play_status('hide');
            });
            playerVimeo.on('pause', function () {
              toggle_play_status('show');
            });
          }

          function toggle_play_status() {
            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'hide';

            if (mode == 'hide') {
              play_button.classList.add('hidden');
              preview.classList.add('hidden');
            } else {
              play_button.classList.remove('hidden');
              preview.classList.remove('hidden');
            }
          }
        } //}

      }
    };

    for (var i = 0; i < video_blocks.length; i++) {
      var playerVimeo;
      var tag;
      var firstScriptTag;
      var player;

      _loop(i);
    }
  }
});